import React from "react";
import { Progress, Row, Col } from "reactstrap";
import Badges from "./Badges.jsx";
import "./About.css";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="About">
        <div className="container">
          <h1>ABOUT</h1>
          <Badges />
          <Row>
            <Col md="4">
              <div className="Eddie">
                <img
                  className="rounded-circle"
                  src="/EddieIsMe.jpeg"
                  alt="Eddie Is Me"
                />
                <h5>Who is Eddie?</h5>
                <p>
                  I am a Software developer in Nairobi, Kenya. I have a passion
                  for BlockChain, PWA's and creating dynamic user experiences.
                  <br />
                  Intersted in knowing more? Here is my CV &nbsp;
                  <br />
                  <a href="/#" download="/Edison Waweru CV.pdf">
                    <i className="fas fa-file-pdf fa-2x"></i>
                  </a>
                </p>
                <a href="/#">Let's make something really special.</a>
              </div>
            </Col>

            <Col md="8">
              <div className="Skills">
                <ul>
                  <li>
                    <h6 className="Language">NodeJs</h6>
                    <Progress value={80} />
                  </li>
                  <li>
                    <h6 className="Language">Python</h6>
                    <Progress value={80} />
                  </li>
                  <li>
                    <h6 className="Language">ExpressJs</h6>
                    <Progress value={90} />
                  </li>
                  <li>
                    <h6 className="Language">Flask</h6>
                    <Progress value={70} />
                  </li>
                  <li>
                    <h6 className="Language">ReactJs</h6>
                    <Progress value={90} />
                  </li>
                  <li>
                    <h6 className="Language">Git</h6>
                    <Progress value={80} />
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default About;
